import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import NotFound from 'components/NotFound';
import PageWithSidebar from 'components/PageWithSidebar';
import Tabber from 'components/Tabber';
import SeoRouteEditSeo from 'components/SeoRouteEditSeo';
import MediaEditor from 'components/MediaEditor';
import SeoRouteEditStats from 'components/SeoRouteEditStats';
import SeoRouteSidebar from 'components/SeoRouteSidebar';
import SeoRouteEditForm from 'components/SeoRouteEditForm';

import { withData } from 'lib';
import { SeoRouteEditPageQuery } from '__generated__/SeoRouteEditPageQuery.graphql';

const query = graphql`
  query SeoRouteEditPageQuery($id: ID!) {
    seoRoute(id: $id) {
      ...SeoRouteSidebar_seoRoute
      ...SeoRouteEditForm_seoRoute
      ...SeoRouteEditSeo_seoRoute
      ...MediaEditor_mediable
      ...SeoRouteEditStats_seoRoute
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SeoRouteEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [{ link: '/seo', name: 'Seo' }];

const SeoRouteEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { seoRoute } = usePreloadedQuery<SeoRouteEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!seoRoute) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<SeoRouteSidebar seoRoute={seoRoute} />}
      breadcrumbs={[...breadcrumbs, { name: 'Nuoroda' }]}>
      <Tabber
        tabs={[
          {
            title: 'Bendra informacija',
            component: <SeoRouteEditForm seoRoute={seoRoute} />,
            hash: 'main',
          },
          {
            title: 'SEO',
            component: <SeoRouteEditSeo seoRoute={seoRoute} />,
            hash: 'seo',
          },
          {
            title: 'Nuotrauka',
            component: <MediaEditor limit={1} mediable={seoRoute} />,
            hash: 'media',
          },
          {
            title: 'Statistika',
            component: <SeoRouteEditStats seoRoute={seoRoute} />,
            hash: 'stats',
          },
        ]}
      />
    </PageWithSidebar>
  );
};

export default withData<SeoRouteEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton tabs={4} breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SeoRouteEditPage);
